import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LocationsFilterUpdateEnum } from 'src/app/shared/enums';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
    syncRadioButton: Subject<number> = new Subject();
    syncLocationList: Subject<Array<string>> = new Subject();

    constructor() { }

    searchPanelSelectedCompanyLocationType: LocationsFilterUpdateEnum = LocationsFilterUpdateEnum.COUNTRY;
    searchPanelSelectedContactLocationType: LocationsFilterUpdateEnum = LocationsFilterUpdateEnum.COUNTRY;
    visitorIntelSelectedLocationType: LocationsFilterUpdateEnum = LocationsFilterUpdateEnum.COUNTRY;

    resetSearchPanel() {
        this.searchPanelSelectedCompanyLocationType = LocationsFilterUpdateEnum.COUNTRY;
        this.searchPanelSelectedContactLocationType = LocationsFilterUpdateEnum.COUNTRY;
    }

    resetFilterPanel() {
        this.visitorIntelSelectedLocationType = LocationsFilterUpdateEnum.COUNTRY;
    }
}
